import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, Text, ScrollView } from 'react-native';
import { faCalendar, faFilter, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Chips, Drawer, MaterialCalendar } from '../../components';
import { formatShortMonthYear } from '../../utils/dateUtils';
import filterTypeJson from '../../assets/data/filterType.json';

export const SearchEvents = ({ navigation }: any) => {
  const [showCalDrawer, setShowCalDrawer] = useState<boolean>(false);
  const [showTypeDrawer, setShowTypeDrawer] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [showClose, setShowClose] = useState<boolean>(false);
  const [typeSelected, setTypeSelected] = useState<string>('');
  const [firstTypeSelected, setFirstTypeSelected] = useState<string>('');
  const [filterTypeData] = useState<any>(filterTypeJson);
  const [chipsData, setChipsData] = useState<any[]>(filterTypeData);
  const [lastChipsData, setLastChipsData] = useState<any[]>(filterTypeData);
  // const [applyClick, setApplyClick] = useState<boolean>(false);

  useEffect(() => {
    // Function to compare old object values to new object values
    // const compareObjects = (oldData: string | any[], newData: any[]) => {
    //   for (let i = 0; i < oldData.length; i++) {
    //     if (oldData[i].isSelected !== newData[i].isSelected) {
    //       console.log(`'isSelected' property changed for object at index ${i}`);
    //     }
    //     // You can add more comparison logic for other properties here if needed
    //   }
    // };
    // // Compare old chipsData to the new chipsData after each update
    // compareObjects(chipsDataRef.current, chipsData);
    // // Update the reference to the latest chipsData
    // chipsDataRef.current = chipsData;
    // console.log('is chips data>>>', chipsData.filter(chip => console.log(`${chip.id} is ${chip.isSelected}`)));
    // console.log('is lastChips data>>>', lastChipsData.filter(chip => console.log(`${chip.id} is ${chip.isSelected}`)));
    // console.log('is applyClick>>>', applyClick);
  }, [chipsData, lastChipsData]);

  const handleHighlighted = (selectedItemIndex: any) => {
    // Toggle the isSelected state for the clicked chip
    const updatedChipsData = chipsData.map((item, idx) => ({
      ...item,
      isSelected: idx === selectedItemIndex ? !item.isSelected : item.isSelected,
      showClose: idx === selectedItemIndex ? !item.showClose : item.showClose,
    }));

    setChipsData(updatedChipsData);
  };

  const onCickApply = () => {
    // show the text on type chips
    const chipCount = chipsData.filter(chip => chip.isSelected).length;
    if (chipCount > 0) {
      setTypeSelected(chipCount.toString());
      // Update the 'firstTypeSelected' only if there is a selected chip
      const selectedData = chipsData.find(item => item.isSelected);
      if (selectedData) {
        setFirstTypeSelected(selectedData.text);
      }
    } else {
      setTypeSelected('');
      setFirstTypeSelected('Type');
    }

    setLastChipsData(chipsData);
    setShowTypeDrawer(false);

    // show the text on type chips
    // const chipCount = chipsData.filter((chip) => chip.isSelected).length
    // if (chipCount > 0)
    //   setTypeSelected(chipsData.filter((chip) => chip.isSelected).length.toString());
    // else
    //   setTypeSelected('')

    // // show the selected count on type chips
    // const selectedData = chipsData.filter((item) => item.isSelected);
    // if (selectedData.length > 0)
    //   setFirstTypeSelected(selectedData[0].text)
    // else
    //   setFirstTypeSelected('Type')

    // setLastChipsData(chipsData)
    // setShowTypeDrawer(false)
  };

  const clearHighlights = () => {
    const updateChipsData = chipsData.map(item => ({
      ...item,
      isSelected: false,
      showClose: false,
    }));
    setChipsData(updateChipsData);
  };

  const promptCalendar = () => {
    setShowCalDrawer(true);
  };

  const promptTypeFilter = () => {
    setShowTypeDrawer(true);
    setChipsData(lastChipsData);
  };

  const handleSelectDate = (date: Date) => {
    setSelectedDate(date);
    setShowClose(true);
  };

  const handleCloseChipSelection = () => {
    setSelectedDate(null);
    setShowClose(false);
    setShowCalDrawer(false);
  };

  const renderTypeFilterItem = () => {
    return (
      <ScrollView horizontal showsHorizontalScrollIndicator={false}>
        <View style={styles.typeFilterItemContainer}>
          {chipsData.map((chip, index) => (
            <Chips
              key={index}
              text={chip.text}
              icon={faPlus}
              showClose={chip.showClose}
              highlight={chip.highlight}
              onClick={() => handleHighlighted(index)}
              isSelected={chip.isSelected}
            />
          ))}
        </View>
      </ScrollView>
    );
  };

  return (
    <View style={styles.container}>
      <Chips
        text={selectedDate ? formatShortMonthYear(selectedDate) : 'Date'}
        icon={faCalendar}
        showClose={showClose}
        highlight={false}
        onClick={promptCalendar}
        onCloseClick={handleCloseChipSelection}
      />
      <Chips
        text={firstTypeSelected ? firstTypeSelected : 'Type'}
        icon={faFilter}
        showClose={false}
        highlight={false}
        onClick={promptTypeFilter}
        totalTypeSelected={typeSelected}
        // onCloseClick={ handleCloseChipSelection }
      />
      <Drawer
        id="drawer.calendar"
        type="onCancel"
        visible={showCalDrawer}
        onClose={() => setShowCalDrawer(false)}
        onOK={() => handleSelectDate}
      >
        <View>
          <MaterialCalendar onSelectMonth={handleSelectDate} />
        </View>
      </Drawer>
      <Drawer
        id="drawer.type"
        type="ok"
        okLabel="Apply"
        visible={showTypeDrawer}
        onClose={() => setShowTypeDrawer(false)}
        onOK={() => onCickApply()}
      >
        <View style={styles.typeFilterContainer}>
          <Text style={styles.typeFilterTitle}>Select type filter(s)</Text>
          <TouchableOpacity onPress={() => clearHighlights()}>
            <Text style={styles.typeFilterClearText}>Clear</Text>
          </TouchableOpacity>
        </View>
        {renderTypeFilterItem()}
      </Drawer>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    backgroundColor: '#fff',
  },
  typeFilterContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
  },
  typeFilterTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: 'black',
  },
  typeFilterClearText: {
    fontSize: 15,
    fontWeight: 'bold',
    textDecorationLine: 'underline',
    color: '#8e00ff',
  },
  typeFilterItemContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    paddingHorizontal: 0,
    paddingVertical: 4,
  },
});
